import OldEnterpriseManage from '@/pages/oldPlatform/oldEnterpriseManage'

export default [
  {
    path: '/oldEnterpriseManage',
    name: 'OldEnterpriseManage',
    component: OldEnterpriseManage,
    meta: { name: '企业管理', keepAlive: true }
  }
]



// WEBPACK FOOTER //
// ./src/router/oldPlatform/oldEnterpriseManage.js